/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_NewInputs */

const en_header_trending_new = /** @type {(inputs: Header_Trending_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Header_Trending_NewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_new = /** @type {((inputs?: Header_Trending_NewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_NewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_new(inputs)
});
export { header_trending_new as "header.trending.new" }